import { ActivatedRoute, Router } from "@angular/router";
import { saveAuth } from "./../../../util/auth";
import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { errorHandler } from "src/app/util/errorHandler";

@Component({
  selector: "app-login-page",
  templateUrl: "./login-page.component.html",
})
export class LoginPageComponent implements OnInit {
  constructor(private httpClient: HttpClient, private router: Router, private route: ActivatedRoute) {}
  ngOnInit(): void {
    const message: string = location.hash.slice(1);
    if (message) {
      let messageContent = message.split("#");
      this.notification = {
        error: !(messageContent.length > 1 && messageContent[1] == "success"),
        message: messageContent[0].replace("%20", " ").replace(/\+/g, " "),
      };

    }
    this.getPortalType();

  }

  payload = {
    StudentNo: "",
    Password: "",
  };
  formLabels = {
    userNameLabel: "",
    PasswordLabel: "",
    PortalLink: "",
    PortalLabel: "",
    ForgotLabel: "",
    ForgotLink: "",
  };
  loading = false;
  isApplication = false;
  notification = {};
  errors: validations = {};

  getPortalType() {
    
    this.isApplication = this.route.snapshot.paramMap.get("portal") == 'application';
    if (this.isApplication) {
      this.formLabels = {
        userNameLabel: "Family ID",
        PasswordLabel: "Surname (small letter)",
        PortalLink: "schoolportal",
        PortalLabel: "School",
        ForgotLabel: "Create Family Profile",
        ForgotLink: "/application/create-family",
      }
    }
    else {
      this.formLabels = {
        userNameLabel: "Student Number/Family ID",
        PasswordLabel: "Password",
        PortalLink: "application",
        PortalLabel: "Application",
        ForgotLabel: "Forgot Password?",
        ForgotLink: "/forgot-password",
      }
    }
  }

  login() {
    if (!this.payload.StudentNo || !this.payload.Password) {
      this.errors.StudentNo = !this.payload.StudentNo;
      this.errors.Password = !this.payload.Password;
      return;
    } else {
      this.errors = {};
    }

    this.notification = {};
    this.loading = true;

    const params = new HttpParams({
      fromObject: this.payload,
    });

    const baseUrl = `${environment.BASE_URL}/${this.isApplication ? 'applications' : 'users'}/login`;
    this.httpClient
      .post(baseUrl, params)
      .subscribe({
        next: (res: any) => {
          saveAuth({ ...res?.Data, Matric: res?.Data.Student.StudentNo });

          let studentPortalUrl = res?.Data?.StudentPortalUrl;

          location.href = studentPortalUrl + (this.isApplication ? "/application" :
            res?.Data?.ResetPassword ? "/reset-password" : "/");
        },
        error: (err) => {
          this.loading = false;
          this.notification = errorHandler(err);
        },
      })
      .add(() => {
        saveAuth([], "_courses");
        saveAuth({}, "_checks");
        saveAuth(null, "_news");
        saveAuth(null, "_deadlines");
        saveAuth([], "_accommodation");
        saveAuth([], "_slider");
        saveAuth([], "_requirements");
        saveAuth({}, "_passport");
        saveAuth(this.isApplication, "_isApplication");
      });
  }
}

interface validations {
  StudentNo?: boolean;
  Password?: boolean;
}

interface payload {
  StudentNo: string;
  Password: string;
}
